module.exports = __webpack_public_path__ + "img/lilv.d1a42f62.svg";